export const expense_reports = {
  'EAF_Master': {
    oldname: "PN3ExpenseRpt",
    name: "Master",
    procedure: 'sp_PN3_RPT_EAF_Master_JasperRpt',
    title: 'EXPENSE AUTHORIZATION FORM SUMMARY',
    show: false,
    sub_reports: ['EAF_High_Dollar', 'EAF_Pres', 'EAF_SecTreas', 'EAF_Summary', 'EAF_NonDept'],
  },
  'EAF_High_Dollar': {
    oldname: "PN3HighDollarRpt",
    name: "High Dollar",
    subname: "PN3EAFHighDollarSubRpt1",
    procedure: 'sp_PN3_RPT_over10000_JasperRpt',
    title: 'HIGH DOLLAR ($10,000 AND OVER) AUTHORIZED EXPENSES REPORT',
  },
  'EAF_Pres': {
    oldname: "PN3PresidentRpt",
    name: "President",
    subname: "PN3EAFPresidentSubRpt2",
    procedure: 'sp_PN3_RPT_President_JasperRpt',
    title: 'PRESIDENT SAUNDERS AUTHORIZED EXPENSES REPORT',
  },
  'EAF_SecTreas': {
    oldname: "PN3SecTreRpt",
    name: "Sec-Treas",
    subname: "PN3EAFSecTreSubRpt3",
    procedure: 'sp_PN3_RPT_SecTre_JasperRpt',
    title: 'SECRETARY-TREASURER McBRIDE AUTHORIZED EXPENSES REPORT',
  },
  'EAF_Summary': {
    oldname: "PN3SummaryRpt",
    name: "Summary",
    subname: "PN3EAFSummarySubRpt4",
    procedure: 'sp_PN3_RPT_Summary_JasperRpt',
    title: 'AUTHORIZED EXPENSES REPORT',
  },
  'EAF_NonDept': {
    oldname: "PN3NonDeptRpt",
    name: "Non-Dept",
    subname: "PN3EAFNonDeptSubRpt5",
    procedure: 'sp_PN3_RPT_NonDept_JasperRpt',
    title: 'NON-DEPARTMENTAL EXPENSE AUTHORIZATIONS REPORT'
  },
};


export const contribution_reports = {
  'CAF_Master': {
    oldname: "PN3ContributionRpt",
    name: "Summary",
    procedure: 'sp_PN3_RPT_CAF_Master_JasperRpt',
    title: 'CAF SUMMARY REPORT',
    // show: false,
    sub_reports: ['CAF_High_Dollar', 'CAF_State'],
  },
  'CAF_High_Dollar': {
    oldname: "PN3CAFHighDollarRpt",
    name: "High Dollar",
    procedure: 'sp_PN3_RPT_CAF_over10000_JasperRpt',
    title: 'AUTHORIZED CONTRIBUTIONS REPORT APPROVING $10,000 OR MORE',
  },
  'CAF_State': {
    oldname: "PN3CAFStateRpt",
    name: "State",
    procedure: 'sp_PN3_RPT_CAF_JasperRpt',
    title: 'AUTHORIZED CONTRIBUTIONS REPORT',
    subtitle: 'SORTED BY STATE AND ALPHABETICAL WITHIN STATE',
    custom: true, // state based not dept based
    order: ["StateSegment", "VendorName", "LastManagerApprovedDateTime" ],
    segment: { title: "State", field: "StateSegment" }
  }
}
